module.exports = __webpack_public_path__ + "static/media/city@2x.1f467d25.png";